import { css } from '@emotion/react';
import theme from 'styled-theming';
import { fonts, colors, zindex } from '../styles/theme';

// Nav (mobile) settings
export const mobileNavHeight = '30px';
export const mobileItemColor = colors.grey.primary;
export const mobileItemHoverColor = colors.blue.primary;

// Account switcher settings
export const switcherHeight = '34px';

// Nav settings
export const navHeight = '50px';
export const navIconSize = fonts.sans.size.xlarge;

export const navBarColor = theme('mode', {
  default: colors.grey.secondary,
  v1: colors.blue.primary,
});

export const navShadowColor = theme('mode', {
  default: colors.grey.lightest,
  v1: colors.blue.secondaryLight,
});

export const navAccentColor = theme('mode', {
  default: colors.grey.secondaryDark,
  v1: colors.blue.primaryDark,
});

export const navItemColor = theme('mode', {
  default: colors.grey.primary,
  v1: colors.blue.secondary,
});

export const navItemHoverColor = theme('mode', {
  default: colors.blue.primaryLight,
  v1: colors.white,
});

export const navActiveItemColor = theme('mode', {
  default: colors.blue.primaryDark,
  v1: colors.white,
});

export const navItemHoverBgColor = theme('mode', {
  default: colors.grey.secondaryLight,
  v1: colors.blue.primaryDark,
});

export const navPlainTextColor = theme('mode', {
  default: colors.grey.altDark,
  v1: colors.blue.secondaryDark,
});

export const navAvatarHoverColor = theme('mode', {
  default: colors.blue.primaryLight,
  v1: colors.grey.altDark,
});

// bc v1 things
export const navWrapperTheme = theme('mode', {
  default: `
    box-shadow: 0 1px 2px 2px ${navShadowColor};
  `,
});

// Dropdown styling
export const dropdownPosition = {
  left: css`
    position: relative;
    ul {
      right: 0px;
      left: auto;
      border-radius: 2px 0 2px 2px;
      @media screen and (max-width: 1000px) {
        right: 0;
      }
    }
  `,
};

export const navDropdownStyles = css`
  z-index: ${zindex.modal.above};
  padding-top: 0;
  position: static;
  > ul {
    margin-top: -1px;
    min-width: auto;
  }
  &:hover::after {
    color: ${mobileItemHoverColor};
  }
  &::after {
    width: 20px;
    font-size: 16px;
  }
  @media screen and (max-width: 1000px) {
    position: relative;
    max-height: none;
    background: none;
    border-radius: 0;
    width: 100%;
    padding-top: 0;
    > ul {
      position: relative;
      border: 0;
      padding: 0 10px;
      box-shadow: none;
      top: auto;
      right: auto;
      &::before {
        display: none;
      }
      li {
        margin: 2px 0;
        a {
          font-size: ${fonts.sans.size.small};
          padding: 0 10px;
          text-transform: none;
          &:hover {
            background: none;
          }
        }
      }
    }
  }
`;
